import React, { forwardRef } from 'react'
import styled from 'styled-components'

import { MainMenuFragmentFragment } from '../../../../graphql/gatsby'
import { MegaMenuEntry } from '../MegaMenuEntry'
import * as Styled from './styled'

type MainMenuEntry = NonNullable<NonNullable<MainMenuFragmentFragment['mainMenu']>[number]>
type SubMenuEntries = NonNullable<MainMenuEntry['childEntries']>

export interface MegaMenuColumnProps {
  className?: string
  entries: SubMenuEntries
  leftOffset: number
  seeAllEntry?: MainMenuEntry | null
}

const MegaMenuColumn = forwardRef<HTMLDivElement, MegaMenuColumnProps>(function MegaMenuColumn(
  { className, entries, leftOffset, seeAllEntry },
  ref,
) {
  return (
    <div
      className={className}
      ref={ref}
      style={leftOffset ? { marginLeft: `${leftOffset}px` } : {}}
    >
      <Styled.MegaMenuList>
        {seeAllEntry && (
          <Styled.MegaMenuListEntry>
            <Styled.MegaMenuSeeAllLink link={seeAllEntry.link}>SEE ALL</Styled.MegaMenuSeeAllLink>
          </Styled.MegaMenuListEntry>
        )}
        {entries.reduce((acc: React.ReactElement[], subMenuEntry, index) => {
          if (!subMenuEntry) return acc
          acc.push(<MegaMenuEntry menuEntry={subMenuEntry} key={subMenuEntry._id || index} />)
          return acc
        }, [])}
      </Styled.MegaMenuList>
    </div>
  )
})

const StyledMegaMenuColumn = styled(MegaMenuColumn)`
  float: left;
  width: 30%;
  margin-left: 30px;
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.coolGray.cool500};
`

export { StyledMegaMenuColumn as MegaMenuColumn }
